import {DayOfWeekLogProps} from '../type';
import {useGetDayOfWeekLayoutData} from './useGetDayOfWeekLayoutData';

type Params = DayOfWeekLogProps;

export const useGetDayOfWeekEventLog = (params: Params) => {
  const layoutData = useGetDayOfWeekLayoutData(params);
  const {currentDayItem, currentReferenceItem, currentSortItem} = layoutData;

  const getCustomProps = () => ({
    page_day: currentDayItem.name,
    page_filter: currentReferenceItem.name,
    page_sort: currentSortItem.name,
  });

  return {
    getCustomProps,
  };
};
